import type {WalletProvider} from 'src/types';
import type {NetworkType} from 'src/v2/state/types';
import type {DynamicWalletKey} from '@stripe-internal/wallet-connect-wrapper';

export const WALLET_KEY_NETWORK_MAPPING: {
  [provider in WalletProvider]: {
    [networkType in NetworkType]: DynamicWalletKey | null;
  };
} = {
  MetaMask: {
    solana: 'metamasksol',
    evm: 'metamask',
  },
  Phantom: {
    solana: 'phantom',
    evm: 'phantomevm',
  },
  'Coinbase Wallet': {
    solana: 'coinbasesolana',
    evm: 'coinbase',
  },
  WalletConnect: {
    evm: 'walletconnect',
    solana: null,
  },
};

export const getNetworkTypeFromWalletKey = (
  key: DynamicWalletKey,
): NetworkType => {
  const networkType = Object.values(WALLET_KEY_NETWORK_MAPPING)
    .flatMap((networkMapping) => Object.entries(networkMapping))
    .find(([, walletKey]) => walletKey === key)?.[0];

  return networkType as NetworkType;
};

// Map wallet providers to dynamic wallet keys based on network
export const getWalletKey = (
  provider: WalletProvider,
  networkType: NetworkType,
): DynamicWalletKey => {
  const walletKey = WALLET_KEY_NETWORK_MAPPING[provider][networkType];
  if (!walletKey) {
    throw new Error(
      `No wallet key found for provider: ${provider} and network type: ${networkType}`,
    );
  }
  return walletKey;
};
